import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'react-formality'
import { TextField } from '@material-ui/core'
import Comment from './components/Comment'
import connectPropTypes from './utilities/connectPropTypes'
import getNormalisedParameters from './utilities/getNormalisedParameters'
import styles from './PostComments.icss'
import getDecodedURIComponent from './utilities/getDecodedURIComponent'

import Form from './components/Form'

class PostComments extends React.Component {
	constructor(props) {
		super(props)
		const parsedSearch = getNormalisedParameters(this.props.location.search)
		this.state = {
			postId: getDecodedURIComponent(parsedSearch.postid || props.match.params.postId),
			addComment: getDecodedURIComponent(parsedSearch.addcomment || props.match.params.addComment),
			commentId: getDecodedURIComponent(parsedSearch.commentid || props.match.params.commentId),
			hasPosted: false
		}
		this.form = React.createRef()
		this.handleValidFormSubmit = this.handleValidFormSubmit.bind(this)
		this.handleCommentDeleteBinder = this.handleCommentDeleteBinder.bind(this)
	}

	componentDidMount() {
		this.props.appHeading({
			text: this.context.translate('Comments')
		})
		this.props.appShowBottomBar(false)
		this.props.appBackButtonFunction(() => this.props.appRedirect(`/post/${this.state.postId}`))
		this.props.appBottomNavBarHandleClick(() => {
			this.form.current.submit()
			this.setState({ hasPosted: true }, () => this.props.appShowBottomNavBar(false))
		})
		this.props.appBottomNavBarLabelNext(this.context.translate('Post'))
		this.props.postCommentsFetch({ postId: this.state.postId })
	}

	handleCommentDeleteBinder(isPostOwner) {
		return (commentId) => {
			const args = { commentId, postId: this.state.postId }
			if (isPostOwner) {
				this.props.postCommentDeleteByPostOwner(args)
			} else {
				this.props.postCommentDelete(args)
			}
		}
	}

	handleValidFormSubmit({ values }) { // eslint-disable-line class-methods-use-this
		const comment = {
			text: values.text,
			uid: this.props.user.uid,
			userName: this.props.user.userProfile.userName
		}

		this.props.postCommentAdd({ comment, postId: this.state.postId })
		this.setState({ text: values.text })
	}

	render() {
		const { post, user, postComments, postCommentDraft } = this.props
		const postCount = (postComments && postComments.length) || 0
		return !postComments ? null : (
			<section>
				<section>
					{postComments && postComments.map((comment) => {
						const canDelete = (postComments && post) && (post.uid === user.uid || user.isAdmin || comment.uid === user.uid)
						return (
							<Comment
								className={styles.underline}
								key={comment.uid + comment.createdTimestamp + comment.text}
								comment={comment}
								highlight={this.state.commentId === comment.commentId}
								commentDelete={canDelete ? this.handleCommentDeleteBinder(post.uid === user.uid) : undefined}
							/>
						)
					})}
					{postComments && postCount === 0 &&
						<p className={styles.noPosts}>{this.context.translate('No comments yet, be the first!')}</p>
					}
				</section>
				<section className={styles.form} key={`commentText-${this.state.text}`}>
					<Form
						initialValues={{
							text: (postCommentDraft && typeof postCommentDraft.text === undefined) || '' // eslint-disable-line valid-typeof
						}}
						onSubmit={args => args.isValid && this.handleValidFormSubmit(args)}
						ref={this.form}
					>
						{props => (
							<section>
								<Field
									component={TextField}
									name="text"
									value={props.values.text}
									fullWidth
									inputProps={{ 'data-lpignore': true }}
									autoFocus={!this.state.hasPosted && !!this.state.addComment}
									onFocus={() => this.props.appShowBottomNavBar(true)}
									margin="normal"
									label={this.context.translate('Your comment')}
									multiline
									validate={{
										length: { minimum: 1, maximum: 10000 },
										presence: true
									}}
								/>
							</section>
						)}
					</Form>
				</section>
			</section>
		)
	}
}

PostComments.contextTypes = {
	translate: PropTypes.func
}

PostComments.propTypes = {
	location: PropTypes.shape({
		pathname: PropTypes.string.isRequired,
		search: PropTypes.string
	}).isRequired,
	match: PropTypes.shape({
		params: PropTypes.object.isRequired
	}).isRequired,
	appHeading: PropTypes.func.isRequired,
	appRedirect: PropTypes.func.isRequired,
	appShowBottomBar: PropTypes.func.isRequired,
	appShowBottomNavBar: PropTypes.func.isRequired,
	appBackButtonFunction: PropTypes.func.isRequired,
	appBottomNavBarHandleClick: PropTypes.func.isRequired,
	appBottomNavBarLabelNext: PropTypes.func.isRequired,
	post: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	postCommentsFetch: PropTypes.func.isRequired,
	postCommentAdd: PropTypes.func.isRequired,
	postCommentDelete: PropTypes.func.isRequired,
	postCommentDeleteByPostOwner: PropTypes.func.isRequired,
	postComments: PropTypes.array, // eslint-disable-line react/forbid-prop-types
	postCommentDraft: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	user: PropTypes.shape({
		uid: PropTypes.string,
		userProfile: PropTypes.shape({
			userName: PropTypes.string
		})
	}).isRequired
}

PostComments.defaultProps = {
	post: undefined,
	postComments: undefined,
	postCommentDraft: undefined
}

export const testing = {
	PostComments
}

export default connectPropTypes(PostComments)



// WEBPACK FOOTER //
// ./src/PostComments.jsx